import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledBrandsDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};

  @media only ${theme.mediaQuery.allMobiles} {
    padding-top: ${toRem(16)};
  }
  `}
`;

export const StyledBrandsFilterHeaderContainerDiv = styled.div`
  ${rtl`
  margin-bottom: ${toRem(16)};
  `}
`;

export const StyledBrandsItemContainerDiv = styled.div`
  ${rtl`
  .brands-list{
    width: auto;
    }
  .brand-type-header {
    display: flex;
    align-items: center;
    letter-spacing: ${toRem(1.3)};
    margin-top: ${toRem(24)};
    justify-content: space-between;
    .brand-type-label {
      margin-right: ${toRem(5)};
      text-transform: uppercase;
    }

    .brand-type-all-selector {
      margin-left: ${toRem(5)};
      text-decoration: underline;
      font: ${baseVariables.font.fontWeightMedium};
      &.disabled-state {
        pointer-events: none;
      }
    }
  }
  .brand-type-content {
    gap:${toRem(16)};
    margin-top: ${toRem(8)};
    display: grid;
    grid-template-columns: auto auto auto;
    @media only ${baseVariables.mediaQuery.md} {
      grid-template-columns: auto auto auto auto;
    }
  }

  .brand-logo-container {
    box-sizing: border-box;
    height: ${toRem(74)};
    width: auto;
    min-width: ${toRem(158)};
    height: fit-content;
    border: ${toRem(1)} solid ${theme.color['dark-gray-3']};
    border-radius: ${toRem(8)};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.color['base-20']};
    padding: ${toRem(7)} ${toRem(19)};
    overflow:hidden;
    min-height: ${toRem(72)};

    &:hover {
      box-shadow: 0 ${toRem(2)} ${toRem(4)} 0 rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }
    .brand-logo {
      &:hover {
        background-color: transparent;
      }
    }
    .brand-logo-disabled {
      color: ${theme.color['dark-gray-3']};
    }
  }

  .brand-logo-container.active {
    border: ${toRem(2)} solid;
  }

  .brand-logo-container.disabled {
    background-color: ${theme.color['background']};
    pointer-events: none;
    &:hover {
      cursor: default;
      box-shadow: none;
    }
    &:focus {
      cursor: default;
      box-shadow: none;
    }
  }

  @media only ${theme.mediaQuery.allTablets} {
    .brand-logo-container {
      padding: ${toRem(3)} ${toRem(14)};
      min-width:${toRem(118)};
      &:hover {
        box-shadow: none;
        cursor: pointer;
      }
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
    .brand-type-header {
      margin-top: ${toRem(24)};
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .brand-logo-container {
      padding: ${toRem(3)} ${toRem(4)};
      min-height: unset;
      max-height: unset;
      height: ${toRem(66)};
      width: 100%;
      min-width: ${toRem(80)};
    }
    .brand-type-label {
      width: max-content;
    }
    .brand-type-all-selector {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  `}
`;
export const StyledBrandsItemDiv = styled.div`
  ${rtl`
  .brand-logo-XE::before {
    font-size: ${toRem(35)};
    margin-top: ${toRem(15)};
  }
  .brand-logo-MG::before {
    font-size: ${toRem(32)};
    margin-top: ${toRem(10)};
  }
  .brand-logo-MV::before {
    font-size: ${toRem(48)};
    margin-top: ${toRem(4)};
  }
  .portfolio-icon-mvc::before {
    font-size: ${toRem(45)};
    margin-top: ${toRem(10)};
  }
  .brand-logo-DE::before {
    font-size: ${toRem(50)};
    margin-top: ${toRem(4)};
  }
  .brand-logo-SI::before {
    font-size: ${toRem(48)};
    margin-top: ${toRem(10)};
  }
  .brand-logo-XF::before {
    font-size: ${toRem(35)};
    margin-top: ${toRem(14)};
  }
  .brand-logo-BA::before {
    font-size: ${toRem(50)};
    margin-top: ${toRem(16)};
  }
  .brand-logo-RS::before {
    font-size: ${toRem(23.2)};
    margin-top: ${toRem(4)};
  }

  .brand-logo-WH::before {
    font-size: ${toRem(16)};
  }
  .brand-logo-DS::before {
    font-size: ${toRem(12)};
  }
  .brand-logo-SN::before {
    font-size: ${toRem(50)};
    margin-top: ${toRem(15)};
  }

  @media only ${theme.mediaQuery.allMobiles} {
    width: 33.33%;

    .brand-logo-EB::before {
      font-size: ${toRem(14)};
    }
    .brand-logo-RZ::before {
      font-size: ${toRem(36)};
    }
    .brand-logo-LC::before {
      font-size: ${toRem(42)};
    }
    .brand-logo-XR::before {
      font-size: ${toRem(48)};
    }
    .brand-logo-WH::before {
      font-size: ${toRem(12)};
    }
    .brand-logo-JW::before {
      font-size: ${toRem(30)};
    }
    .brand-logo-BG::before {
      font-size: ${toRem(14)};
    }
    .brand-logo-MC::before {
      font-size: ${toRem(48)};
    }
    .brand-logo-SI::before {
      font-size: ${toRem(36)};
    }
    .brand-logo-MV::before {
      font-size: ${toRem(44)};
    }
    .brand-logo-DE::before {
      font-size: ${toRem(48)};
    }
    .brand-logo-WI::before {
      font-size: ${toRem(18)};
    }
    .brand-logo-MD::before {
      font-size: ${toRem(12)};
    }
    .brand-logo-BR::before {
      font-size: ${toRem(40)};
      margin-top: ${toRem(10)};
    }
    .brand-logo-AK::before {
      font-size: ${toRem(30)};
    }
    .brand-logo-TX::before {
      font-size: ${toRem(16)};
    }
    .brand-logo-DS::before {
      font-size: ${toRem(10)};
    }
    .brand-logo-GE::before {
      font-size: ${toRem(36)};
    }
    .brand-logo-CY::before {
      font-size: ${toRem(12)};
    }
    .brand-logo-FP::before {
      font-size: ${toRem(46)};
      margin-top: ${toRem(10)};
    }
    .brand-logo-SH::before {
      font-size: ${toRem(30)};
    }
    .brand-logo-FI::before {
      font-size: ${toRem(20)};
    }
    .brand-logo-PR::before {
      font-size: ${toRem(32)};
    }
    .brand-logo-AR::before {
      font-size: ${toRem(48)};
    }
    .brand-logo-AL::before {
      font-size: ${toRem(34)};
    }
    .brand-logo-OX::before {
      font-size: ${toRem(26)};
    }
    .brand-logo-RI::before {
      font-size: ${toRem(14)};
    }
    .brand-logo-TS::before {
      font-size: ${toRem(26)};
    }
    .brand-logo-ER::before {
      font-size: ${toRem(34)};
    }
    .brand-logo-EL::before {
      font-size: ${toRem(48)};
    }
    .brand-logo-XE::before {
      font-size: ${toRem(24)};
      margin-top: ${toRem(6)};
    }
    .brand-logo-MG::before {
      font-size: ${toRem(22)};
      margin-top: ${toRem(6)};
    }
    .brand-logo-XF::before {
      font-size: ${toRem(24)};
      margin-top: ${toRem(12)};
    }
    .brand-logo-BA::before {
      font-size: ${toRem(44)};
    }
   .brand-logo-RS::before {
      font-size: ${toRem(18)};
      margin-top: ${toRem(4)};
    }
  }

  @media only ${theme.mediaQuery.smallMobile} {
    width: 50%;
  }
`}
`;
export const StyledBrandModalDiv = styled.div`
  ${rtl`
  .pop-up-footer {
    padding: ${toRem(12)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(20)} ${toRem(32)};
    }
  }
  .all-filters{
    padding-left:${toRem(24)} !important;
    padding-right:${toRem(10)} !important;
  }

  .all-filters.custom-scrollbar.android{
    padding-right: ${toRem(10)} !important;
  }
  
  .all-filters.custom-scrollbar.ios{
    padding-right: ${toRem(24)} !important;
  }

  .filter-option-button.active {
    background-color: ${theme.color['close-silver']};
  }
  .filter-option-button {
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  .filter-option-button:focus {
    outline: 0px solid -webkit-focus-ring-color;
  }
  `}
`;
